// extracted by mini-css-extract-plugin
export default {"wrapper":"Statistics__wrapper-PzKu","content":"Statistics__content-FMPA"};